import { API_GET_COMPARISON, API_GET_COMPARISON_SUCCESS, } from '../actions/ComparisonActions';
const INITIAL_STATE = {
    items: [],
};
// eslint-disable-next-line default-param-last
export default (state = {}, { payload, type }) => {
    switch (type) {
        case API_GET_COMPARISON: {
            return Object.assign({}, INITIAL_STATE);
        }
        case API_GET_COMPARISON_SUCCESS: {
            return { items: [...payload.list] };
        }
        default: {
            return state;
        }
    }
};
